import { DialogConfig } from "@moe/priv/types/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAppContext } from "@web/route-services/root/AppContext";
import { useRef } from "react";
import { toast } from "sonner";

export function useDeleteChar() {
  const queryClient = useQueryClient();
  const loadingRef = useRef<number | string>();
  const { createDialog, access } = useAppContext();

  const { mutate } = useMutation({
    mutationFn: async (id: number) => {
      return await access.character.delete(id);
    },
    onMutate: () => {
      loadingRef.current = toast.loading("Deleting character...");
    },
    onSettled: () => {
      if (loadingRef.current) toast.dismiss(loadingRef.current);
      queryClient.invalidateQueries({ queryKey: ["profileCards"] });
    },
    onSuccess: () => {
      toast.success("Character deleted!");
    }
  });

  const deleteChar = (id: number, onSuccess?: () => void) => {
    const config: DialogConfig = {
      title: "Delete Character",
      description: `Are you sure you want to delete this Character? This will also delete all chats with this character.`,
      actionLabel: "Delete",
      onAction: () => {
        mutate(id, { onSuccess: () => onSuccess?.() });
      }
    };
    createDialog(config);
  };

  return { deleteChar };
}
